<template>
  <div class="MoveGroupMember">
    <van-nav-bar
      title="移动到"
      right-text="确定"
      fixed
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div class="move">
      <van-cell-group v-for="item in groupList" :key="item+''" :style="{padding:'0 10px'}">
        <van-radio-group v-model="radio">
          <van-radio v-if="item.ug_id !== ug_id" :name="item.ug_id">
            <van-cell :title="item.ug_name" :value="item.group_user.length+'人'">
              <van-image
                class="err-image-header"
                slot="icon"
                width="30px"
                round
                height="30px"
                :src="attach_url+item.ug_icon"
              />
            </van-cell>
          </van-radio>
        </van-radio-group>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoveGroupMember",
  data() {
    return {
      member_id: "", // 需要移动的群成员id
      ug_id: "",
      groupList: [],
      radio: "",
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre
    };
  },
  computed: {
    verify: function() {
      if (!this.radio) {
        return { flag: false, msg: "请选择群" };
      }
      return { flag: true, msg: "ok" };
    }
  },
  methods: {
    loadData() {
      var params = {
        groupOwner_id: this.u_id,
        token: this.token,
        u_id: this.u_id
      };
      var url = this.Conf.serverUrl + "GroupChatroom/getGroupByGroupOwner" + "?num="+Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          this.groupList = response.data.result;
          // console.log(response.data)
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "GroupManage",
        query: {
          ug_id: this.ug_id
        }
      });
    },
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    // 移动群成员至群主其他的群内
    onClickRight() {
      if (!this.verify.flag) {
        this.$toast.fail(this.verify.msg);
      } else {
        var params = {
          member_id: this.member_id,
          group_id: this.radio,
          token: this.token,
          u_id: this.u_id,
          old_group_id: this.ug_id
        };
        var url = this.Conf.serverUrl + "Groups/moveGroupMember";
        this.$axios
          .post(url, this.$qs.stringify(params))
          .then(response => {
            switch (response.data.code) {
              case 200:
                this.$toast.success(response.data.msg);
                this.loadData();
                break;
              case 40001:
                this.$toast.fail(response.data.msg);
                break;
            }
          })
          .catch(error => {});
      }
    }
  },
  created() {
		this.getStateConfigs();
    var params = this.$route.query;
    this.member_id = params.member_id;
    this.ug_id = params.ug_id;
    this.loadData();
    // console.log(this.member_id);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Group/MoveGroupMember.vue